module.exports = __webpack_public_path__ + "img/logo-ppd_letras_2.e40623f1.png";